import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { getVendorserviceworkorderList_action } from "../../../actions/exhibitor_module_actions/manual_Forms_actions/manual_forms_action";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../utils/constants";
import moment from "moment";
import Modal from "react-modal";
import { emailValidator, mobileNoValidator } from "../../../utils/Validator";
import { insertStallDesignRequest_action, getStallDesignRequestStatusDtl_action } from '../../../actions/vendor_module_action/vendor_stallDesignRequest_action'

class ManualFormsVendorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      vendorList: [],
      isIndirectAccess: sessionStorage.getItem("isIndirectAccess"),
      Deadline: this.props.location.state?.Deadline || null,
      StatusID: this.props.location.state?.StatusID || null,
      ManualFormsID: this.props.location.state?.ManualFormsID || null,
      ManualFormsName: this.props.location.state?.ManualFormsName || null,
      ServiceID: this.props.location.state?.ServiceID || null,
      isVendorSelectionAllowed: this.props.location.state?.isVendorSelectionAllowed || null,
      IsNonEmpanelCard: this.props.location.state?.IsNonEmpanelCard || null,
      openScopeIds: [],
      isOpen: false,
      companyName: "",
      companyNameErr: "",
      personName: "",
      personNameErr: "",
      Email: "",
      EmailErr: "",
      Mobile: "",
      MobileErr: "",
      currentDate: moment().format("DD-MM-YYYY"),
      isOpen2: false,
      vendorCompanyName: '',
      VendorID: '',
      Remark: '',
      RemarkErr: '',
      RequestDtlList: [],
      isDisableRemark: false
    };
  }

  componentDidMount() {
    this.getVendorserviceworkorderList();
    window.scrollTo(0, 0);
    console.log("this.props--------->", this.props);
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    this.getStallDesignRequestStatusDtl()
  }

  toggleScopeBox = (id) => {
    this.setState((prevState) => {
      if (prevState.openScopeIds.includes(id)) {
        // close if already open
        return { openScopeIds: prevState.openScopeIds.filter((scopeId) => scopeId !== id) };
      } else {
        // open and keep others open
        return { openScopeIds: [...prevState.openScopeIds, id] };
      }
    });
  };

  handleOpenForm = (data, IsEmpanel) => {
    const {
      ManualFormsID,
      Deadline,
      StatusID,
      isIndirectAccess,
      ServiceID,
      companyName,
      companyNameErr,
      personName,
      personNameErr,
      Email,
      EmailErr,
      Mobile,
      MobileErr,
    } = this.state;
    const routeMap = {
      1: "/fascia-form",
      2: "/exhibitorbadge",
      3: "/exhibitorDetails",
      4: "/visaApplication",
      5: "/edirectoryList",
      6: "/keywordsInformation",
      7: "/stallDesign",
      8: "/aditionalfurniture",
      9: "/stallpossesion",
      10: "/powerConnection",
      11: "/freightForward",
      12: "/water",
      13: "/airConnectionApplication",
      14: "/carPassesApplication",
      15: "/liquareLicense",
      16: "/leadRetrievalConnectionApplication",
      17: "/meetingRoomRequestForm",
      18: "/delegateMeeting",
      19: "/visitorMeetingApplication",
      20: "/internetConnection",
      21: "/housekeepingConnection",
      22: "/securityApplication",
      23: "/cateringServices",
      24: "/hostHostessRequirements",
      25: "/brandingApportunityAndAdvertisement",
      26: "/rentalAudioAndVedioEquipment",
      27: "/exhibitorContractorBadgeApplication",
      28: "/plantAndBeautification",
      29: "/sponsorship",
      30: "/hotelEnquiry",
      31: "/prAgency",
      32: "/photographyAndVideography",
    };
    const path = routeMap[ManualFormsID];
    const deadlineState = isIndirectAccess == "true" ? null : Deadline;
    console.log("data===>", data)
    if (IsEmpanel) {
      const obj = {
        VendorID: data.VendorID,
        CompanyName: data.CompanyName,
        PersonName: data.VendorName,
        EmailID: data.PrimaryEmail,
        MobileNo: data.MobileNo && data.MobileNo.split("-")[1]?.trim() !== "" ? data.MobileNo : null,
        VendorMDName: data.VendorMDName,
        VendorMDMobileNo: data.VendorMDMobileNo,
        VendorMDEmaiId: data.VendorMDEmaiId,
      };
      this.props.navigate(path, {
        state: {
          Deadline: deadlineState,
          StatusID: sessionStorage.getItem("isIndirectAccess") == "true" ? null : StatusID,
          ServiceID,
          ManualFormsID,
          VendorDetails: obj,
          ActualDeadline: this.props.location?.state?.ActualDeadline,
          VendorDetailShow: this.props.location?.state?.isITMEBilling == 0 ? obj : null,
          is_View:
            sessionStorage.getItem("isIndirectAccess") == "true"
              ? false
              : sessionStorage.getItem("RoleIDSS") != 1,
          Is_View:
            sessionStorage.getItem("isIndirectAccess") == "true"
              ? false
              : sessionStorage.getItem("RoleIDSS") != 1,
        },
      });
    } else {
      this.inputValidate();
      if (
        companyName != "" &&
        companyName != null &&
        personName != "" &&
        personName != null &&
        Email != "" &&
        Email != null &&
        Mobile != "" &&
        Mobile != null
      ) {
        const emailValidate = emailValidator(Email);
        if (emailValidate) {
          this.setState({ EmailErr: emailValidate });
          return toastError(emailValidate);
        }
        const MobileValidate = mobileNoValidator(Mobile);
        if (MobileValidate) {
          this.setState({ MobileErr: MobileValidate });
          return toastError(MobileValidate);
        }
        const obj = {
          VendorID: null,
          CompanyName: companyName,
          PersonName: personName,
          EmailID: Email,
          MobileNo: Mobile,
          VendorMDName: null,
          VendorMDMobileNo: null,
          VendorMDEmaiId: null,
        };
        this.props.navigate(path, {
          state: {
            Deadline: deadlineState,
            StatusID: sessionStorage.getItem("isIndirectAccess") == "true" ? null : StatusID,
            ServiceID,
            ManualFormsID,
            VendorDetails: obj,
            ActualDeadline: this.props.location?.state?.ActualDeadline,
            VendorDetailShow: this.props.location?.state?.isITMEBilling == 0 ? obj : null,
            is_View:
              sessionStorage.getItem("isIndirectAccess") == "true"
                ? false
                : sessionStorage.getItem("RoleIDSS") != 1,
            Is_View:
              sessionStorage.getItem("isIndirectAccess") == "true"
                ? false
                : sessionStorage.getItem("RoleIDSS") != 1,
          },
        });
      } else {
        toastError("Please enter mandatory feilds!");
      }
    }
  };

  getVendorserviceworkorderList = () => {
    const { ServiceID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getVendorserviceworkorderList_action(ServiceID)
      .then((data) => {
        if (data.error !== 1) {
          const grouped = this.groupWorkOrders(data.data);
          this.setState({ vendorList: grouped, isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
      });
  };

  // groupWorkOrders = (data) => {
  //   if (!Array.isArray(data)) return [];
  //   const grouped = Object.values(
  //     data.reduce((acc, item) => {
  //       if (!acc[item.WorkOrderID]) {
  //         acc[item.WorkOrderID] = {
  //           WorkOrderID: item.WorkOrderID,
  //           VendorID: item.VendorID,
  //           CompanyName: item.CompanyName,
  //           VendorName: item.VendorName,
  //           PrimaryEmail: item.PrimaryEmail,
  //           MobileNo: item.MobileNo,
  //           YearOfEstablishment: item.YearOfEstablishment,
  //           NoOfStaff: item.NoOfStaff,
  //           NoOfEventHandled: item.NoOfEventHandled,
  //           AboutCompany: item.AboutCompany,
  //           USP: item.USP,
  //           ClientEventList: item.ClientEventList,
  //           MainServiceID: item.MainServiceID,
  //           AccessibleTo: item.AccessibleTo,
  //           List: [],
  //         };
  //       }
  //       acc[item.WorkOrderID].List.push({
  //         DeliverablesService: item.DeliverablesService,
  //         Quantity: item.Quantity,
  //         Amount: item.Amount,
  //         Currency: item.Currency,
  //         IsStockAvailable: item.IsStockAvailable,
  //       });
  //       return acc;
  //     }, {})
  //   );
  //   return grouped.sort((a, b) => b.WorkOrderID - a.WorkOrderID);
  // };

  groupWorkOrders = (data) => {
    if (!Array.isArray(data)) return [];

    const grouped = Object.values(
      data.reduce((acc, item) => {
        if (!acc[item.WorkOrderID]) {
          acc[item.WorkOrderID] = {
            WorkOrderID: item.WorkOrderID,
            VendorID: item.VendorID,
            CompanyName: item.CompanyName,
            VendorName: item.VendorName,
            PrimaryEmail: item.PrimaryEmail,
            MobileNo: item.MobileNo,
            YearOfEstablishment: item.YearOfEstablishment,
            NoOfStaff: item.NoOfStaff,
            NoOfEventHandled: item.NoOfEventHandled,
            AboutCompany: item.AboutCompany,
            USP: item.USP,
            ClientEventList: item.ClientEventList,
            MainServiceID: item.MainServiceID,
            AccessibleTo: item.AccessibleTo,
            List: [],
            VendorMDName: item.VendorMDName,
            VendorMDMobileNo: item.VendorMDMobileNo,
            VendorMDEmaiId: item.VendorMDEmaiId,
          };
        }

        // ✅ Only push if AccessibleTo == 2
        if (item.AccessibleTo === 2) {
          acc[item.WorkOrderID].List.push({
            DeliverablesService: item.DeliverablesService,
            Quantity: item.Quantity,
            Amount: item.Amount,
            Currency: item.Currency,
            IsStockAvailable: item.IsStockAvailable,
          });
        }

        return acc;
      }, {})
    );

    return grouped.sort((a, b) => b.SeqNo - a.SeqNo);
  };

  inputValidate() {
    const {
      companyName,
      companyNameErr,
      personName,
      personNameErr,
      Email,
      EmailErr,
      Mobile,
      MobileErr,
    } = this.state;
    if (companyName == "" || companyName == null) {
      this.setState({
        companyNameErr: "Please enter company name",
      });
    }
    if (personName == "" || personName == null) {
      this.setState({
        personNameErr: "Please enter person name",
      });
    }
    if (Email == "" || Email == null) {
      this.setState({
        EmailErr: "Please enter email name",
      });
    }
    if (Mobile == "" || Mobile == null) {
      this.setState({
        MobileErr: "Please enter mobile name",
      });
    }
  }

  RequestPop(isDisable, data) {
    if (isDisable) {
      this.setState({
        isOpen2: true,
        Remark: data.StatusID == 3 ? data.RefusedRemark : data.Remark,
        isDisableRemark: isDisable,
      })
    } else {
      this.setState({
        isOpen2: true,
        VendorID: data.VendorID,
        vendorCompanyName: data.CompanyName
      })
    }
  }

  insertStallDesignRequest() {
    const { VendorID, Remark } = this.state
    if (Remark?.trim() == '') {
      this.setState({ RemarkErr: "Please enter remark", Remark: '' })
      return toastError("Please enter remark")
    }
    this.setState({ isLoading: true })
    this.props
      .insertStallDesignRequest_action(VendorID, Remark)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Request successfully sent to the vendor.")
          this.setState({
            isLoading: false,
            isOpen2: false,
          })
          this.getStallDesignRequestStatusDtl()
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getStallDesignRequestStatusDtl() {
    this.setState({ isLoading: true })
    this.props
      .getStallDesignRequestStatusDtl_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            RequestDtlList: data.data
          })
        } else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const {
      currentDate,
      isLoading,
      vendorList,
      ManualFormsName,
      Deadline,
      openScopeIds,
      isOpen,
      companyName,
      companyNameErr,
      personName,
      personNameErr,
      Email,
      EmailErr,
      Mobile,
      MobileErr,
      isVendorSelectionAllowed,
      IsNonEmpanelCard,
      DeadlineDate,
      isOpen2,
      vendorCompanyName,
      Remark,
      RemarkErr,
      RequestDtlList,
      isDisableRemark
    } = this.state;
    const isDeadlinePassed =
      Deadline &&
      moment.utc(Deadline).isValid() &&
      moment.utc().startOf("day").isAfter(moment.utc(Deadline).startOf("day"))
    return (
      <>
        {isLoading && <Loader />}
        <ToastContainer />
        <ExhibitorHeader />
        <ExhibitorDrawer />
        <div className="page">
          <div className="page-main">
            <div className="main-content with-dr-container">
              <div className="width-dr-nav">
                <div className="row">
                  <ExhibitorTopMenu />
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="card rounded-0 pt-1 shadow-none">
                    <div className="card-body p-2">
                      <div className="container-fluid pb-0">
                        {/* <h6 className="my-2 mb-0 text-primary d-flex">
                                                    {ManualFormsName}
                                                    <small className="d-flex align-items-center text-muted mx-3" style={{ fontSize: 13 }}>
                                                        <i className="bi bi-calendar-event me-2 text-success" />
                                                        <span className="dedline-text">
                                                            Deadline: {
                                                                (() => {
                                                                    const todayUTC = moment.utc().startOf('day');
                                                                    const deadlineUTC = moment.utc(Deadline).startOf('day');
                                                                    const daysLeft = deadlineUTC.diff(todayUTC, 'days');

                                                                    if (daysLeft < 0) {
                                                                        return <span className="text-danger">The deadline has passed.</span>;
                                                                    } else if (daysLeft === 0) {
                                                                        return (
                                                                            <>
                                                                                <strong>{deadlineUTC.format("D MMMM, YYYY")}</strong>
                                                                                <span className="text-danger">&nbsp; Today is the last date</span>
                                                                            </>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <>
                                                                                <strong>{deadlineUTC.format("D MMMM, YYYY")}</strong>
                                                                                <span className="text-danger">&nbsp; {daysLeft} days left</span>
                                                                            </>
                                                                        );
                                                                    }
                                                                })()
                                                            }
                                                        </span>
                                                    </small>
                                                </h6> */}
                        <div className="row mt-4">
                          <h6 className="mt-3">
                            <span className="text-danger">
                              {" "}
                              Last Date Of Submission -{" "}
                              {this.props.location?.state?.ActualDeadline
                                ? moment(this.props.location.state.ActualDeadline).format(
                                  "DD-MM-YYYY"
                                )
                                : "-"}
                            </span>
                          </h6>
                        </div>

                        <div className="row" id="vendorList">
                          {vendorList.length > 0 ? (
                            vendorList.map((item) => (
                              <div className="col-md-4" key={item.WorkOrderID}>
                                <input
                                  type="radio"
                                  name="vendor"
                                  className="vendor-radio"
                                  id={`vendor${item.WorkOrderID}`}
                                />
                                <div className="custom-card p-3 position-relative">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <h6 className="mb-0">{item.CompanyName}</h6>
                                  </div>
                                  <p className="text-muted small mb-1">
                                    <i className="fa fa-envelope-o" /> {item.PrimaryEmail}
                                  </p>
                                  <p className="text-muted small mb-2">
                                    <i className="fa fa-phone" /> {item.MobileNo}
                                    {/* <span className="rating mt-1 float-end">⭐⭐⭐☆☆</span> */}
                                  </p>
                                  <div className="form-check mt-1 p-0 d-flex">
                                    <button
                                      className="btn btn-aqua toggle-scope"
                                      type="button"
                                      disabled={isDeadlinePassed}
                                      onClick={() =>
                                        this.toggleScopeBox(`scope${item.WorkOrderID}`)
                                      }
                                    >
                                      View Company Profile
                                    </button>
                                    {this.props.location?.state?.ManualFormsName == "STALL DESIGN APPROVAL BY ARCHITECT" ? (
                                      <>
                                        {(() => {
                                          const request = RequestDtlList?.find(
                                            (req) => req.VendorID === item.VendorID
                                          );

                                          return request ? (
                                            request.StatusID == 2 ? (
                                              <button
                                                className="btn btn-aqua proceed-btn mx-2"
                                                disabled={isDeadlinePassed}
                                                onClick={() => this.handleOpenForm(item, true)}
                                              >
                                                Proceed
                                              </button>
                                            ) : (
                                              <>
                                                <button
                                                  className={`btn proceed-btn ml-2 ${request.StatusID == 1 ? "btn-aqua" : "btn-danger"
                                                    }`}
                                                  disabled={true}
                                                >
                                                  {request.StatusID == 1 ? "Request Sent" : "Refused"}
                                                </button>
                                                &nbsp;
                                                <i
                                                  onClick={() => this.RequestPop(true, request)}
                                                  style={{ cursor: "pointer", fontSize: "18px" }}
                                                  className="bi bi-info-circle text-aqua mx-1"
                                                  title={`View ${request.StatusID == 1
                                                      ? "Request Remark"
                                                      : "Refused Remark"
                                                    }`}
                                                ></i>
                                              </>
                                            )
                                          ) : (
                                            <button
                                              className="btn btn-aqua proceed-btn mx-2"
                                              disabled={isDeadlinePassed}
                                              onClick={() => this.RequestPop(false, item)}
                                            >
                                              Request
                                            </button>
                                          );
                                        })()}
                                      </>
                                    ) : (
                                      <button
                                        className="btn btn-aqua proceed-btn mx-2"
                                        disabled={isDeadlinePassed}
                                        onClick={() => this.handleOpenForm(item, true)}
                                      >
                                        Proceed
                                      </button>
                                    )}
                                  </div>

                                  {/* Scope Box */}
                                </div>
                                <div
                                  className="scope-box start-0 w-100 p-2 bg-white border border-primary rounded shadow"
                                  style={{
                                    zIndex: 9999,
                                    overflowX: 'hidden',
                                    maxHeight: "350px",
                                    overflowY: "auto",
                                    top: "100%",
                                    left: 0,
                                    display: openScopeIds.includes(`scope${item.WorkOrderID}`)
                                      ? "block"
                                      : "none",
                                  }}
                                >

                                  <ul className="list-unstyled mb-0 px-2 text-left">
                                    <li className="mb-2">
                                      <i className="fa fa-building-o grid-icon me-2" />
                                      <span className="text-muted">Year of Establishment:</span>
                                      <span className="ms-1">
                                        {item.YearOfEstablishment || "-"}
                                      </span>
                                    </li>
                                    <li className="mb-2">
                                      <i className="fa fa-users grid-icon me-2" />
                                      <span className="text-muted">No. of Staff:</span>
                                      <span className="ms-1">{item.NoOfStaff || "-"}</span>
                                    </li>
                                    <li className="mb-2">
                                      <i className="fa fa-calendar-check-o grid-icon me-2" />
                                      <span className="text-muted">No. of Events Handled:</span>
                                      <span className="ms-1">{item.NoOfEventHandled || "-"}</span>
                                    </li>
                                    <li className="mb-2">
                                      <i className="fa fa-id-card-o grid-icon me-2" />
                                      <span className="text-muted">About Company:</span>
                                      <span className="ms-1" style={{ whiteSpace: "pre-line" }}>
                                        {!item.AboutCompany ? "" : <br />}
                                        {item.AboutCompany || "-"}
                                      </span>
                                    </li>
                                    <li className="mb-2">
                                      <i className="fa fa-newspaper-o grid-icon me-2" />
                                      <span className="text-muted">USP:</span>
                                      <span className="ms-1" style={{ whiteSpace: "pre-line" }}>
                                        {!item.USP ? "" : <br />}
                                        {item.USP || "-"}
                                      </span>
                                    </li>
                                  </ul>
                                  {item.List.length > 0 &&
                                    <div className="table-responsive">
                                      <h6 className="pt-3">Service & Price</h6>
                                      <table className="table table-bordered align-middle mb-0">
                                        <thead className="table-light">
                                          <tr>
                                            <th>Services</th>
                                            <th className="text-center">Quantity</th>
                                            <th className="text-center">Price</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item.List.map((service, idx) => (
                                            <tr
                                              key={idx}
                                              class={
                                                service.IsStockAvailable
                                                  ? ""
                                                  : "bg-light text-muted"
                                              }
                                            >
                                              <td>{service.DeliverablesService}</td>
                                              <td className="text-center">{service.Quantity}</td>
                                              <td className="text-center">{service.Amount}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  }
                                </div>
                              </div>
                            ))
                          ) : (
                            <div></div>
                          )}
                          {IsNonEmpanelCard && (
                            <div className="col-md-4 px-0">
                              <div className="custom-card p-3 position-relative">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <h6 className="mb-0">Non Empanel Service Partner</h6>
                                </div>
                                <p className="text-muted small mb-2">
                                  In case a non-empanelled vendor is engaged for this service,
                                  kindly provide the vendor details.
                                </p>
                                <div className="form-check mt-1 p-0 d-flex">
                                  <button
                                    className="btn btn-aqua proceed-btn"
                                    disabled={isDeadlinePassed}
                                    onClick={() => this.setState({ isOpen: true })}
                                  >
                                    Proceed
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}


                        </div>

                        <div className="row w-auto m-0">
                          <button
                            className="btn btn-gray d-block my-3 w-auto"
                            onClick={() => window.history.back()}
                          >
                            Back
                          </button>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header text-white p-2">
                <h6 className="modal-title fw-normal">
                  Non-Empanel Service Partner Details
                </h6>
                <button
                  type="button "
                  class="btn-close btn-close-white"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isOpen: false })}
                >
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div className="col-xl-6 mb-1">
                    <label htmlFor="validationCustom03">
                      Company Name<span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyName}
                      maxLength={150}
                      onChange={(e) =>
                        this.setState({
                          companyName: e.target.value
                            .split(" ")
                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(" "),
                          companyNameErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {companyNameErr}
                      </span>
                    }
                  </div>
                  <div className="col-xl-6 mb-1">
                    <label htmlFor="validationCustom03">
                      Person Name<span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="validationCustom03"
                      required=""
                      value={personName}
                      maxLength={150}
                      onChange={(e) =>
                        this.setState({
                          personName: e.target.value
                            .split(" ")
                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(" "),
                          personNameErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {personNameErr}
                      </span>
                    }
                  </div>
                  <div className="col-xl-6 mb-1">
                    <label htmlFor="validationCustom03">
                      Email<span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="validationCustom03"
                      required=""
                      value={Email}
                      maxLength={100}
                      onChange={(e) =>
                        this.setState({
                          Email: e.target.value,
                          EmailErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {EmailErr}
                      </span>
                    }
                  </div>
                  <div className="col-xl-6 mb-1">
                    <label htmlFor="validationCustom03">
                      Mobile<span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="validationCustom03"
                      required=""
                      value={Mobile}
                      maxLength={10}
                      onChange={(e) =>
                        this.setState({
                          Mobile: e.target.value.replace(/\D/, ""),
                          MobileErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {MobileErr}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                {/* <div class="form-group text-right mod-fot"> */}
                <button
                  className="btn btn-aqua mx-2"
                  onClick={() => this.handleOpenForm(null, false)}
                >
                  Proceed
                </button>
                <button
                  type="button"
                  class="btn btn-gray"
                  data-dismiss="modal"
                  style={{ marginLeft: "5px" }}
                  onClick={() => this.setState({ isOpen: false })}
                >
                  Close
                </button>
                {/* </div> */}
              </div>
            </div>
          </div>
        </Modal>

        <Modal isOpen={isOpen2} onRequestClose={() => this.setState({ isOpen2: false })}>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header text-white p-2">
                <h6 className="modal-title fw-normal">
                  {RequestDtlList?.[0]?.['StatusID'] == 1 ? 'Request Remark' : RequestDtlList?.[0]?.['StatusID'] == 3 ? 'Refused Remark' : 'Add Remark for Request'}
                </h6>
                <button
                  type="button "
                  class="btn-close btn-close-white"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isOpen2: false,Remark:'' })}
                >
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div className="col-xl-12 mb-1">
                    <label htmlFor="validationCustom03">
                      Remark<span className="text-red">*</span>
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      rows={10}
                      disabled={isDisableRemark}
                      value={Remark}
                      maxLength={2000}
                      onChange={(e) =>
                        this.setState({
                          Remark: e.target.value,
                          RemarkErr: "",
                        })
                      }
                    />
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {RemarkErr}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                {/* <div class="form-group text-right mod-fot"> */}
                {!isDisableRemark &&
                  <button
                    className="btn btn-aqua mx-2"
                    onClick={() => this.insertStallDesignRequest()}
                  >
                    Request
                  </button>
                }
                <button
                  type="button"
                  class="btn btn-gray"
                  data-dismiss="modal"
                  style={{ marginLeft: "5px" }}
                  onClick={() => this.setState({ isOpen2: false, isDisableRemark: false, Remark:'' })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, { getVendorserviceworkorderList_action, insertStallDesignRequest_action, getStallDesignRequestStatusDtl_action })(ManualFormsVendorList)
);
